<main-menu-component />
<router-outlet></router-outlet>
